import type {
  GetPackageRequestTypes,
  GetPackageResponseTypes,
} from 'entities/document/api/types';
import { apiAuthClient } from 'shared/api/lib/apiAuthClient';

export const getPackage = async (params: GetPackageRequestTypes) => {
  const url = `/api/v2/packages/${params.packageId}`;
  const response = await apiAuthClient.get<GetPackageResponseTypes>(url);

  return response.data.data;
};
